module.exports = __webpack_public_path__ + "img/7b.763d841c.jpg";